import {createContext} from 'react'
import {ActivityTimelineContextProps} from './types/ActivityTimelineContextProps'
export const ActivityTimelineContext = createContext<ActivityTimelineContextProps>({})
